import { Link } from 'react-router-dom';

const referencedFiles = [
  { name: 'Procedimiento-LOTO.docx', confidence: '92%' },
  { name: 'Matriz-IPERC-2026.xlsx', confidence: '87%' },
];

export default function SafelineAiHubBanner() {
  return (
    <section
      className="relative overflow-hidden py-20"
      style={{ backgroundColor: '#07111A' }}
    >
      {/* Background glow */}
      <div className="absolute inset-0 bg-gradient-to-r from-teal-500/10 to-cyan-500/10"></div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* LEFT CONTENT */}
          <div>
            {/* Badge */}
            <span className="inline-flex items-center bg-teal-500/10 border border-teal-400/30 text-teal-300 px-4 py-2 rounded-full text-sm font-semibold tracking-wide">
              NUEVO · Copiloto de IA para HSE
            </span>

            {/* Title */}
            <h2 className="text-4xl lg:text-5xl font-extrabold text-white mt-8 leading-tight">
              Safeline <span className="text-teal-400">Ai Hub</span>
            </h2>

            {/* Description */}
            <p className="text-slate-300 text-xl mt-8 leading-relaxed max-w-2xl">
              El copiloto de prevención de riesgos que domina IPERC, ATS,
              investigación de incidentes y normativa. Se apoya en los
              documentos reales de tu organización —citando la fuente— y te
              entrega el Word, Excel o PowerPoint listo para presentar.
            </p>

            {/* FEATURE CARDS */}
            <div className="grid sm:grid-cols-2 gap-6 mt-10">
              {/* CARD 1 */}
              <div
                className="rounded-2xl p-6 border border-white/10 transition-all duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: '#18384C',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
                }}
              >
                <div className="w-12 h-12 bg-teal-500/15 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-search-eye-line text-2xl text-teal-400"></i>
                </div>

                <h3 className="text-white font-semibold text-lg">
                  Investigación de Incidentes
                </h3>

                <p className="text-white/80 text-sm mt-3 leading-relaxed">
                  Línea de tiempo, causa raíz y acciones correctivas listas
                  para presentar.
                </p>
              </div>

              {/* CARD 2 */}
              <div
                className="rounded-2xl p-6 border border-white/10 transition-all duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: '#18384C',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
                }}
              >
                <div className="w-12 h-12 bg-teal-500/15 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-shield-flash-line text-2xl text-teal-400"></i>
                </div>

                <h3 className="text-white font-semibold text-lg">
                  Matrices IPERC
                </h3>

                <p className="text-white/80 text-sm mt-3 leading-relaxed">
                  Peligros, riesgos, controles y criticidad, listos para
                  auditoría.
                </p>
              </div>

              {/* CARD 3 */}
              <div
                className="rounded-2xl p-6 border border-white/10 transition-all duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: '#18384C',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
                }}
              >
                <div className="w-12 h-12 bg-teal-500/15 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-file-shield-2-line text-2xl text-teal-400"></i>
                </div>

                <h3 className="text-white font-semibold text-lg">
                  Auditorías y Cumplimiento
                </h3>

                <p className="text-white/80 text-sm mt-3 leading-relaxed">
                  Checklists, hallazgos y normativa vigente en Latinoamérica.
                </p>
              </div>

              {/* CARD 4 */}
              <div
                className="rounded-2xl p-6 border border-white/10 transition-all duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: '#18384C',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
                }}
              >
                <div className="w-12 h-12 bg-teal-500/15 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-file-chart-2-line text-2xl text-teal-400"></i>
                </div>

                <h3 className="text-white font-semibold text-lg">
                  Informes Ejecutivos
                </h3>

                <p className="text-white/80 text-sm mt-3 leading-relaxed">
                  Word, Excel y PowerPoint listos para presentar a tu equipo.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-12">
              <Link
                to="/safeline-ai-hub"
                className="inline-flex items-center bg-teal-500 hover:bg-teal-600 transition-all duration-300 text-white px-8 py-4 rounded-xl text-base font-semibold shadow-xl hover:shadow-2xl hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-300"
              >
                Conocer Safeline Ai Hub
              </Link>
            </div>
          </div>

          {/* RIGHT PREVIEW PANEL */}
          <div className="relative flex justify-center">
            {/* Glow */}
            <div className="absolute inset-0 bg-teal-500/20 blur-3xl rounded-full"></div>

            {/* MOCK APP PREVIEW — refleja la UI real de Safeline Ai Hub */}
            <Link
              to="/safeline-ai-hub"
              className="relative block w-full max-w-lg transition-all duration-300 hover:scale-[1.02]"
            >
              <div
                className="relative rounded-3xl shadow-2xl border border-white/10 overflow-hidden"
                style={{ backgroundColor: '#111827' }}
              >
                {/* WORKSPACE HEADER */}
                <div className="flex items-center gap-3 px-6 py-4 border-b border-white/10">
                  <div className="w-7 h-7 rounded-md bg-white/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-sm text-white"></i>
                  </div>

                  <span className="text-sm font-semibold text-white">
                    Workspace
                  </span>

                  <span className="ml-auto rounded-full bg-white/10 px-3 py-1 text-xs text-white/70">
                    Proyecto: Planta Norte
                  </span>

                  <span className="rounded-full bg-amber-500/15 px-3 py-1 text-xs font-semibold text-amber-400">
                    1.180 créditos
                  </span>
                </div>

                {/* CONVERSATION */}
                <div className="px-6 pt-6 space-y-4">
                  {/* USER PROMPT */}
                  <div className="rounded-xl bg-amber-600 px-4 py-3 text-sm font-medium text-white leading-relaxed">
                    Redáctame el informe del incidente de la Línea 3 con los
                    documentos del proyecto.
                  </div>

                  {/* AI RESPONSE */}
                  <div className="rounded-xl border border-white/10 bg-white/[0.04] px-4 py-3 text-sm text-white/80 leading-relaxed">
                    Listo. Redacté el informe apoyándome en 2 documentos de tu
                    proyecto, siguiendo la estructura de tus informes
                    anteriores.
                  </div>
                </div>

                {/* FILE REFERENCES */}
                <div className="px-6 pt-4 flex flex-wrap gap-2">
                  {referencedFiles.map((file) => (
                    <span
                      key={file.name}
                      className="inline-flex items-center gap-1.5 rounded-lg border border-white/10 bg-white/[0.03] px-3 py-1.5 text-xs text-white/70"
                    >
                      <i className="ri-file-text-line text-amber-400"></i>
                      {file.name}
                      <span className="text-white/40">· {file.confidence}</span>
                    </span>
                  ))}
                </div>

                {/* DOWNLOAD */}
                <div className="px-6 py-6">
                  <div className="rounded-xl bg-amber-500 text-center py-3 text-sm font-semibold text-gray-900 flex items-center justify-center gap-2">
                    <i className="ri-download-2-line"></i>
                    Descargar Informe-Incidente.docx
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
